<template>
<div>
  <b-container fluid class="bg-white">
    <b-row class="py-4">
      <b-col>
        <h1 style="font-size: 24px; font-weight: bold;">Data Elements</h1>
        <p>Explore data elements from all frameworks in one place. You can filter, sort and use free text search to find data elements.</p>
      </b-col>
    </b-row>
    <b-row class="mb-4" v-if="permission.add">
      <b-col>
        <div>
          <b-button class="mr-2" v-if="permission.add" variant="outline-primary" :to="{ name: 'FormNew', params: { model: 'dataelement' }}">New data element</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="mb-4" style="display: flex; height: 30px;">
          <sort-interface class="mr-4" namespace="dataelements" :rows="rows" v-model="rowsSorted" :optionsProperty="sortProperties"></sort-interface>
          <search-interface namespace="dataelements" :rows="rowsSorted" v-model="rowsSearched"></search-interface>
        </div>
        <b-pagination
          inline
          v-model="currentPage"
          :total-rows="rowsSearched.length"
          :per-page="perPage"
          class="mt-3"
        ></b-pagination>
        <div class="mb-3" v-for="item in showRowsPage" :key="item.id">
          <line-item :item="item" :trim="400"></line-item>
        </div>
        <b-pagination
          inline
          v-model="currentPage"
          :total-rows="rowsSearched.length"
          :per-page="perPage"
          class="mt-3"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import ac from '@/libs/accesscontrol'
import LineItem from '@/views/metrics/DataElementSimple.vue'
import SearchInterface from '@/components/SearchInterfaceV1.vue'
import SortInterface from '@/components/SortInterfaceV1.vue'

export default {
  name: 'DataElements',
  components: {
    LineItem,
    SearchInterface,
    SortInterface
  },
  computed: {
    rows: function () {
      return this.$store.state.dataelements
    },
    showRowsPage: function () {
      const start = (this.currentPage - 1) * this.perPage
      const end = this.currentPage * this.perPage
      return this.rowsSearched.slice(start, end)
    },
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  data () {
    return {
      perPage: 20,
      currentPage: 1,
      permission: {
        add: false
      },
      rowsSearched: [],
      rowsSorted: [],
      sortProperties: [
        { value: 'name', text: 'Name' }
      ],
      staticDataProperties: [
      ]
    }
  },
  created: function () {
    document.title = "ESG Metrics"
    this.permission.add = ac.can(this.user.acgroups).createAny('dataelement').granted
  }
}
</script>

<style>
</style>
